/* Info component on the Scene Component
   for the Workspace Guide */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Scene.module.css";

const InfoWorkspace = ({setShowWorkInfo}) => {
  return (
    <div>
      <Row className="my-3">
        <Col md={{span: 10, offset: 1}}>
        <div className={`px-3 py-2 ${styles.SubTitle6 }`}> 
        <div className={`mt-0 pb-2 `}>
            <span className={`float-right ${styles.Close }`} 
            onClick={() => setShowWorkInfo(false) } >Close</span> 
            <p className={`${styles.Red} text-center`} 
            style={{ textTransform: 'uppercase'}}>Workshop Instructions</p>
        </div>
        <hr className={`my-0`}/>
            <p className="pt-2"><span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}>Workshop</span> to Design and Collaborate on Production items 
              from the Scene, by Department, adding them
              to the Tracker under Minor, Medium or Major labels.
            </p>
            <p className="pt-2">
            <span className={`${styles.Red}`}>*</span> Major project elements, such as Locations, Characters or Props should be collaborated 
            on in the Scene where they <span className={`${styles.Red}`}>first</span> appear in the Script.
            </p>
            <p className="pt-2"><span className={`${styles.Red}`}>*</span> Use <span className={`${styles.Red}`}>Requirements</span> to inform
           what is needed, collaborate in the <span className={`${styles.Red}`}>Workspace</span> and 
           use <span className={`${styles.Red}`}>Finals</span> to contain the the final choices.
           </p>
            <p className="pt-2"><span className={`${styles.Red}`}>*</span> The Universal Department can be used for all Scene work 
            instead of individual Departments if desired.
            </p>
            <p className="pt-2"><span className={`${styles.Red}`}>*</span> Use the Workspace <span className={`${styles.Red}`}>Guide</span> to indicate which
                Departments will be worked on for this Scene.</p>
            <p className="pt-2">
            <span className={`${styles.Red}`}>*</span> The <span className={`${styles.Red}`}>Quick Find Posts</span> page facilitates
            quick and precise locating of relevant Workspace Posts.
            Retrieve Feed, Starred or Liked Posts here or use the 
            "Posts by Department" section to find all relevant Requirement and Workspace posts by Department.
            </p>
            <hr className={`mt-2 mb-0`}/>
         </div> 
        </Col>
      </Row>
    </div>
  )
}

export default InfoWorkspace